import React, { useContext } from 'react'

import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Box, List, Typography } from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'

import ListEcommerce from '~/components/Ecommerce/ListEcommerce'
import { useLiterals } from '~/components/Literals'

import { trackApi, OnlineStoreContext } from '.'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

const useStyles = makeStyles({
  listStoreOnline: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
    minHeight: 0,
    gridColumn: 'span 2',
    overflow: 'hidden',
    backgroundColor: '#FFF',
  },
})

export function ListOnlineStore() {
  const classes = useStyles()
  const theme = useTheme()

  const { getLiteral } = useLiterals()
  const { currentProduct, position, config, showOffers, totalOffers, offerMinMax, showProductValue } =
    useContext(OnlineStoreContext)

  const handleLogger = (data) => {
    const product = currentProduct

    trackApi(
      { event: 'seeOnlineStore', url: data.url, subdomain: config.brandName, price: data.price },
      product,
      data,
      config,
      position,
    )
  }

  const regex = !showOffers ? /(?:de)|(?:US)\$|(?:R)\$|\$/g : /(?:US)\$|(?:R)\$|\$/g

  return (
    <Box className={classes.listStoreOnline}>
      {showProductValue ? (
        <Box
          paddingY={2}
          paddingX={3}
          display="flex"
          gridGap={8}
          borderBottom="1px solid #EEEBEB"
          sx={{
            [theme.breakpoints.down(365)]: {
              flexDirection: 'column',
              alignItems: 'center',
            },
          }}
        >
          <Typography>{`${totalOffers} ${getLiteral('2131').replace(regex, '')}`}</Typography>
          {showOffers && (
            <strong style={{ fontSize: 16 }}>
              {getLiteral('1206', [`R$ ${offerMinMax.min}`, `R$ ${offerMinMax.max}`])}
            </strong>
          )}
        </Box>
      ) : null}

      <SimpleBar style={{ overflow: 'auto', height: '100%' }}>
        <List style={{ padding: 0 }}>
          <ListEcommerce configEcommerce={config} openEcommerce={currentProduct} handleLogger={handleLogger} />
        </List>
      </SimpleBar>

      <Box display="flex" alignItems="center" justifyContent="flex-start" bgcolor="#EEEBEB" padding={1}>
        <InfoOutlined style={{ color: '#999', fontSize: 16 }} />
        <Typography variant="body1" style={{ fontSize: 12, padding: 8, marginLeft: -2 }}>
          {getLiteral('2392')}
        </Typography>
      </Box>
    </Box>
  )
}
